(function () {
    angular
        .module('appback')
        .directive('ngCitologianew', citologianew);

    citologianew.$inject = ['ResultadosService', 'GenerallabService', '$timeout'];

    function citologianew(ResultadosService, GenerallabService, $timeout) {
        return {
            restrict: 'EA',
            templateUrl: '/backend/resultadopeticion/template?name=citologianew.twig',
            scope: {
                item: '=',
                animal: '=',
                centro: '='
            },
            link: function (scope) {
                const defaultExtra = {
                    resultado: {
                        extensiones: [{ diagnostico: [] }],
                    }
                };
                scope.citologias = [];
                scope.generalLab = GenerallabService;

                function initStructure() {
                    // Aseguramos nivel 1: resultado
                    if (!scope.item.resultado || Array.isArray(scope.item.resultado)) {
                        scope.item.resultado = {};
                    }

                    // Aseguramos nivel 2: extra (y su contenido)
                    const extra = scope.item.resultado.extra;

                    // Si extra no existe, es un array, o extra.resultado es un array/no existe:
                    const isInvalid = !extra ||
                        Array.isArray(extra) ||
                        !extra.resultado ||
                        Array.isArray(extra.resultado);

                    if (isInvalid) {
                        scope.item.resultado.extra = angular.copy(defaultExtra);
                    }

                    scope.loadingFields = false;
                }

                // Métodos de la interfaz
                scope.borrarExt = function (index) {
                    const ext = scope.item.resultado.extra.resultado.extensiones;
                    if (ext.length > 1) { // Opcional: evitar borrar la última
                        ext.splice(index, 1);
                    } else {
                        ext[0] = {}; // La reseteamos en lugar de borrarla
                    }
                };

                scope.nuevaExtension = function () {
                    scope.item.resultado.extra.resultado.extensiones.push({ diagnostico: [] });
                };


                scope.getCitologias = function () {
                    ResultadosService.getCitologias(scope.centro.idioma_code)
                        .then(function (response) {
                            scope.citologias = response.data.citologias;
                            console.log("datacitos", response.data)
                        })
                }

                scope.addCito = function (ext, citologia) {
                    if (angular.isUndefined(ext.diagnostico)) {
                        ext.diagnostico = [];
                    }
                    //SI EXISTE LO QUITO Y SI NO LO AÑADO
                    if (ext.diagnostico.includes(citologia.id)) {
                        ext.diagnostico.splice(ext.diagnostico.indexOf(citologia.id), 1);
                        citologia.ordenclick = null;
                    } else {
                        ext.diagnostico.push(citologia.id);
                        citologia.ordenclick = ext.diagnostico.indexOf(citologia.id);
                        if (angular.isDefined(ext.comentario) && ext.comentario != '') {
                            ext.comentario += "<p>----------</p>";
                        }
                        ext.comentario += citologia.plantilla.comentario_extension;
                    }

                    ext.descripcion_cito = citologia.plantilla.descripcion;
                    ext.interpretacion = citologia.plantilla.interpretacion;



                }

                scope.getCitologias();
                $timeout(initStructure);
            }
        };
    }
})();